import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-sheet",
  "use": "google-sheet-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-sheet\"><g clip-path=\"url(#google-sheet_clip0_2_64)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#1D9C5A\" /><path d=\"M5.5 7.5v7h2v-7H14v-2H7.5V2h-2v3.5H2v2h3.5z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-sheet_clip0_2_64\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol